@if (!(loadingSubject | async)) {
  <div
    id="myCity"
    class="my-city">
    <iframe class="my-city__iframe"
      [src]="myCityUrl"
      frameborder="0">
    </iframe>
  </div>
} @else {
  <div class="spinner-wrapper">
    <mat-spinner></mat-spinner>
  </div>
}

